<template>
    <div class="disabled-msg" v-if="value" v-click-outside="closeDisabledMsg">
        <div class="close-btn" @click="closeDisabledMsg">✖</div>
        No llegamos a tiempo de servir planta para esta semana,
        la fecha más cercana está marcada en el calendario.
        Si necesitas una variedad y no llegamos a tiempo, puedes consultar en el disponible.
    </div>
</template>

<script>
import vClickOutside from 'v-click-outside'

export default {
    name: "CustomDatePickerDisabledMessage",
    props: {
        value: {
            type: Boolean
        }
    },
    methods: {
        closeDisabledMsg() {
            this.$emit('input', false);
        }
    },
    directives: {
        clickOutside: vClickOutside.directive
    }
}
</script>

<style scoped>
.disabled-msg {
    width: 100%;
    position: absolute;
    bottom: 0;
    background: #0071bd;
    text-align: left;
    padding: 1rem;
    color: #ffffff;
}

.close-btn {
    position: absolute;
    top: 0;
    right: 0;
    line-height: 1;
    width: 1.5rem;
    height: 1.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}
</style>
